import { storyblokEditable } from "@storyblok/react";
import classNames from "classnames";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { useRouter } from "next/router";
import { useCurrentUser } from "@hooks/use-current-user";
import { useCloseNavSearch } from "@hooks/use-nav-search-hooks";
import Link from "@components/core/Link";

function NavsearchBanner({ blok }) {
  const router = useRouter();
  const user = useCurrentUser();
  const userGroup = user?.user_group || "visitor";
  const closeNavSearch = useCloseNavSearch();

  const backgroundStyle = blok?.background_image?.filename && {
    backgroundImage: `url("${blok?.background_image?.filename}")`,
  };

  function sendLinkTrackerData() {
    const defaultEventData = {
      page: router.asPath,
      tracking_name: "navsearchBanner",
      link: blok.link.url,
      user_group: userGroup,
    };

    ahoy("$click", defaultEventData);
    analytics.track("$click", defaultEventData);
  }

  function handleClick() {
    sendLinkTrackerData();
    closeNavSearch();
  }

  if (!blok) return null;

  return (
    <section className="p-3 bg-lighter-gray">
      <Link
        href={blok.link?.url}
        key={blok._uid}
        onClick={handleClick}
        {...storyblokEditable(blok)}
      >
        <div
          className={classNames(
            blok.background_image?.filename && "navsearch-banner-background-image",
            "navsearch-banner-container",
          )}
          style={backgroundStyle}
        />
      </Link>
    </section>
  );
}

export default NavsearchBanner;
